import { useRef, useCallback, useEffect } from "react";
import AnalysisOrderForm from "./AnalysisOrder/AnalysisOrderForm";
import AnalysisOrderReadView from "./AnalysisOrder/AnalysisOrderReadView";
import AnalysisResultView from "./AnalysisOrder/AnalysisResultView";
import OiDrawer, { OiDrawerRef } from "./OiDrawer";
import OiForm from "./EventReport/OiForm";
import OiPowderForm from "./PowderOrder/OiPowderForm";
import OiPowderOrderReadView from "./PowderOrder/OiPowderOrderReadView";
import RawMaterialControlForm from "./RawMaterialControl/RawMaterialControlForm";
import RawMaterialControlRead from "./RawMaterialControl/RawMaterialControlRead";
import OiReadReport from "./EventReport/OiReadReport";
import { FileReference } from "./OiReport";
import { useTourContext } from "../../contexts/TourContext";
import { OITour } from "../../tours";
import { useAppDispatch } from "../../app/hooks";
import { openFileGallery as openFileGalleryAction } from "../../Slices/FileGallerySlice";

import { AnalysisOrderProvider, EventReportProvider, PowderProvider, RawMaterialProvider } from "./redux/ReduxContext";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useOiDeepLink } from "./useOiDeepLink";
import { getOiLastRoute, saveOiLastRoute } from "./lastRoute";


export type ViewMode = 'create' | 'read' | 'edit';

export default function OiView() {
    const dispatch = useAppDispatch();
    const drawerRef = useRef<OiDrawerRef>(null);
    const { registerTour, unregisterTour } = useTourContext();
    const location = useLocation();
    const navigate = useNavigate();

    // A Teams deep link (e.g. from an email) takes priority over the last opened route,
    // also when the O&I tab is already open (re-checked on focus/visibility).
    useOiDeepLink(() => {
        const saved = getOiLastRoute();
        if (!saved) return;
        // Navigate right away; API calls wait for the SSO token inside the fetch interceptor.
        navigate(saved, { replace: true });
    });

    useEffect(() => {
        saveOiLastRoute(location.pathname);
    }, [location.pathname]);


    const openFileGallery = useCallback((files: FileReference[], initialIndex: number) => {
        dispatch(
            openFileGalleryAction({
                files: Array.isArray(files) ? files : [],
                initialIndex: Number.isFinite(initialIndex) ? initialIndex : 0,
                title: "Attachments",
            })
        );
    }, [dispatch]);

    useEffect(() => {
        registerTour(OITour);

        // Expose drawer controls for tour
        (window as any).oiDrawerControls = {
            open: () => drawerRef.current?.open()
        };

        return () => {
            unregisterTour(OITour.id);
            delete (window as any).oiDrawerControls;
        };
    }, [registerTour, unregisterTour]);

    return (
        <div className=" ">
            <div className="fixed h-auto min-h-screen inset-0 bg-cover bg-center bg-light dark:bg-dark -z-10" />
            {/* Tour Button */}
            {/* <TourButton
                tourId="oi-tour"
                className="fixed bottom-4 left-10 z-50 "
                label="Tour"
            /> */}
            <div className="flex">


                <OiDrawer

                    startOpen={true}
                />


                <div className="p-4 w-full h-auto  flex flex-row md:-ml-6">
                    <EventReportProvider>
                        <Routes>
                            <Route path="/" element={<div></div>} />
                            <Route path="/eventReport/new" element={<OiForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/eventReport/:uuid" element={<OiReadReport onOpenFileGallery={openFileGallery} />} />
                            <Route path="/editEventReport/:uuid" element={<OiForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/eventReportClone/:uuid" element={<OiForm onOpenFileGallery={openFileGallery} />} />
                        </Routes>
                    </EventReportProvider>

                    {/* <Route path="/powder-allocated" element={<div>Allocated</div>} /> */}
                    <PowderProvider>
                        <Routes>
                            <Route path="/powderOrder/new" element={<OiPowderForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/powderOrder/:uuid" element={<OiPowderOrderReadView onOpenFileGallery={openFileGallery} />} />
                            <Route path="/powderOrderEdit/:uuid" element={<OiPowderForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/powderOrderClone/:uuid" element={<OiPowderForm onOpenFileGallery={openFileGallery} />} />
                        </Routes>
                    </PowderProvider>

                    <RawMaterialProvider>
                        <Routes>
                            <Route path="/rawMaterialControl/new" element={<RawMaterialControlForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/rawMaterialControl/:uuid" element={<RawMaterialControlRead onOpenFileGallery={openFileGallery} />} />
                            <Route path="/rawMaterialControlEdit/:uuid" element={<RawMaterialControlForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/rawMaterialControlClone/:uuid" element={<RawMaterialControlForm onOpenFileGallery={openFileGallery} />} />
                        </Routes>
                    </RawMaterialProvider>

                    <AnalysisOrderProvider>
                        <Routes>
                            <Route path="/analysisOrder/new" element={<AnalysisOrderForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/analysisOrder/:uuid" element={<AnalysisOrderReadView onOpenFileGallery={openFileGallery} />} />
                            <Route path="/analysisOrderEdit/:uuid" element={<AnalysisOrderForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/analysisOrderClone/:uuid" element={<AnalysisOrderForm onOpenFileGallery={openFileGallery} />} />
                            <Route path="/analysisResult/:uuid" element={<AnalysisResultView onOpenFileGallery={openFileGallery} />} />
                            <Route path="/analysisResult/order/:analysisOrderUuid" element={<AnalysisResultView onOpenFileGallery={openFileGallery} />} />
                        </Routes>
                    </AnalysisOrderProvider>

                    {/* {renderContent()} */}
                </div>
            </div>
        </div>
    );
}   
